<template>
  <div id="dictionariesList">
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/skillList' }">技能列表</el-breadcrumb-item>
      <el-breadcrumb-item>词典列表</el-breadcrumb-item>
    </el-breadcrumb>
    <p>
      <router-link :to="{path:'/createDictionaries',query: {skillId: this.skillId,online:this.online}}"><el-button class="font-size-btn" type="primary" round size="small" v-if="!onlineFlag">创建词典</el-button></router-link>
      <router-link :to="{path:'/SystemDictionariesList',query: {skillId: this.skillId,online:this.online}}" style="margin-left: 10px"><el-button class="font-size-btn" type="primary" round size="small" v-if="!onlineFlag">引用系统词典</el-button></router-link>
    </p>
    <div>
      <template>
        <el-table
          :data="tableData"
          style="width: 100%">
          <el-table-column
            prop="chinese_name"
            align="center"
            label="字典中文名">
          </el-table-column>
          <el-table-column
            prop="dict_name"
            align="center"
            label="字典标识名">
          </el-table-column>
          <el-table-column
            prop="origin"
            align="center"
            label="来源">
          </el-table-column>
          <el-table-column
            align="center"
            label="操作">
            <template slot-scope="scope">
              <span v-if='scope.row.origin == "自建"'>
              <!-- <router-link :to="{path:'/editDictionaries',query: {skillId: this.skillId }}"> -->
                <el-button type="text" size="mini" @click='editRow(scope.row)' :disabled="onlineFlag">编辑</el-button>
              <!-- </router-link> -->
              </span>
              <el-button type="text" size="mini" @click='deleteRow(scope.row)' :disabled="onlineFlag">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
      </template>

      <!-- <div class='page'>
        <el-pagination
          background
          @current-change="handleCurrentChange"
          :current-page.sync=page
          layout="prev, pager, next"
          :total="100">
        </el-pagination>
      </div> -->
    </div>
  </div>
</template>
<script>
  import * as API from '@/api'
  export default {
    created(){
      this.getData()
      this.onlineFlag = eval(localStorage.getItem('onlineFlag') == '1')
     // console.log(this.$route.query.skillId)
    },
    data() {
      return {
        skillId:this.$route.query.skillId,
        online:this.$route.query.online,
        value2: true,
        tableData: [],
        page:1,
        limit:15,
        onlineFlag:null
      }
    },
    methods: {
      getData(){
        API.postUsedDict(this.skillId).then((res)=>{
//          console.log(res)
          this.tableData = res.data
        },(err)=>{
           console.log(err)
        })
      },
      deleteRow(row){
        this.$confirm('此操作将永久删除该版本, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
            if(row.origin == '自建'){
              let params = {
                 "delete_user_dicts": [row.dict_id]
              }
              console.log(params)
              API.delCreate(this.skillId,params).then((res)=>{
                 console.log(res)
                 if(res.code == 200){
                   let index =this.tableData.indexOf(row)
                   this.tableData.splice(index,1)
                 }else {
                   this.$message.error('删除失败')
                 }
              //this.tableData = res.data
              },(err)=>{
                this.$message.error('连接错误')
              })
            }else {
              let params = {
                 "delete_sys_dicts": [row.dict_id]
              }
              console.log(params)
              API.delSysDictRef(this.skillId,params).then((res)=>{
                 console.log(res)
                 if(res.code == 200){
                  console.log('12212211212')
                   let index =this.tableData.indexOf(row)
                   this.tableData.splice(index,1)
                 }else {
                   this.$message.error('删除失败')
                 }
              //this.tableData = res.data
              },(err)=>{
                this.$message.error('连接错误')
              })
            }
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          })
        })
      },
      editRow(row){
        this.$router.push({path:'/editDictionaries',query: {skillId: this.skillId,dict_id: row.dict_id,online:this.online}})
      },
      handleCurrentChange(val){
        console.log(`当前页: ${val}`);
        this.page=val;
        // this.getData(val);
      }
    }
  }
</script>
<style  rel="stylesheet/scss" lang="scss">

  #dictionariesList{
    padding:30px;
    p{
      button{
        width: 145px;
        margin-bottom:20px;
      }
    }
    .font-size-btn{
      font-size: 14px;
    }
    .page{
      margin-left: 270px;
      margin-top:30px;
      margin-bottom:30px;
    }
  }


</style>



// WEBPACK FOOTER //
// src/components/skill/dictionaries/DictionariesList.vue